import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { QAState } from './types';

export const getters: GetterTree<QAState, RootState> = {};
